export enum AddOnsRoutes {
  root = 'add-ons',
}
